import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { userAtom } from '@root/entities/auth'
import { basicModeAtom } from '@root/entities/basic'
import { useWebSignIn } from '@root/features/auth/web-sign-in'
import { BasicTopbarCash } from '@root/features/basic'
import { openSearchModalEvent } from '@root/features/services/search-pair'
import { ShortcutId } from '@root/features/shortcut/shortcut-id'
import { PossibleShortcut } from '@root/features/shortcut/ui/possible-shortcut'
import { WalletsDropdown } from '@root/features/wallet/wallets-dropdown'
import { SearchLoupeIcon } from '@root/shared/ui-kit'

import { TopbarClipboardPair } from './topbar-clipboard-pair'
import { IconButton } from './topbar-common'
import { TopbarBalanceFees } from './topbar-end-balance-fees'

import type { ButtonProps } from '@blade/ui-kit'

export const TopbarEnd: React.FC = () => {
  const { t } = useTranslation()
  const openSearch = useAction(openSearchModalEvent)
  const [isLoggedIn] = useAtom((ctx) => !!ctx.spy(userAtom))
  const signIn = useWebSignIn()
  const [tradingMode] = useAtom(basicModeAtom)
  // Basic trades from one dollar balance; the wallet picker, the SOL balance
  // and the fee readouts all describe money it does not spend.
  const inBasic = isLoggedIn && tradingMode === 'basic'

  const renderButton = () => {
    if (inBasic) {
      return <BasicTopbarCash />
    }

    if (isLoggedIn) {
      return <WalletsDropdown />
    }

    const commonProps = {
      variant: 'solid',
      size: 'xxs',
      radius: 'full',
    } satisfies ButtonProps

    return (
      <ButtonOpenApp {...commonProps} color="primary" onClick={() => signIn()}>
        {t('access.door.telegram')}
      </ButtonOpenApp>
    )
  }

  return (
    <TopbarEndRoot>
      {inBasic ? <span /> : <TopbarBalanceFees />}
      <Content>
        <SearchContainer>
          <PossibleShortcut shortcutId={ShortcutId.OpenClipboardPair}>
            <TopbarClipboardPair />
          </PossibleShortcut>
          <PossibleShortcut shortcutId={ShortcutId.Search}>
            <IconButton onClick={openSearch}>
              <SearchLoupeIcon size={16} />
            </IconButton>
          </PossibleShortcut>
        </SearchContainer>
        {renderButton()}
      </Content>
    </TopbarEndRoot>
  )
}

export const TopbarEndRoot = styled.div`
  background: var(--background-1);

  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;

  height: 100%;
  min-width: 380px;
  padding-inline-start: 12px;

  gap: 8px;
`

const Content = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 8px;

  align-items: center;
`

const ButtonOpenApp = styled(Button)`
  height: 26px;
  padding-inline: 8px;
`

const SearchContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 4px;
  align-items: center;
`
